module.exports = __webpack_public_path__ + "static/media/changeUser.411d6247.svg";